export const DATE_FORMAT_WITHOUT_TIME = 'M/d/yy';
export const DATE_FORMAT_WITH_TIME = 'M/d/yy, t';
